"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoLinkExpiryMenuSelector = void 0;
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var luxon_1 = require("luxon");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var Types_1 = require("@CommonFrontendBackend/Projects/Types");
var ShareSettingsOptionSection_1 = require("Common/ShareSettings/ShareSettingsOptionSection");
var StringManipulater_1 = require("Utils/StringManipulater");
exports.AutoLinkExpiryMenuSelector = (0, mobx_react_1.observer)(function (props) {
    return (react_1.default.createElement(ShareSettingsOptionSection_1.ShareSettingsOptionSection, { icon: react_1.default.createElement(icons_1.Clock, null), settingTitle: "Link expiry settings", settingStatus: getSubtext(props), onClick: props.onClick, disabled: props.disabled }));
});
function getSubtext(_a) {
    var projectStatus = _a.projectStatus, subStatus = _a.subStatus, daysUntilExpiry = _a.daysUntilExpiry, expiryDate = _a.expiryDate, expiryEnabled = _a.expiryEnabled;
    if (!expiryEnabled) {
        return "Link will never expire";
    }
    if (projectStatus === Types_1.ProjectStatus.Accepted) {
        return "Accepted pages will never expire";
    }
    if (projectStatus === Types_1.ProjectStatus.Draft) {
        return "".concat((0, StringManipulater_1.pluralise)(daysUntilExpiry, "day"), " after being set live");
    }
    var expiryDateTime = luxon_1.DateTime.fromJSDate(expiryDate);
    if (projectStatus === Types_1.ProjectStatus.Live) {
        if (expiryDate) {
            var hoursToExpiry = expiryDateTime.diffNow("hours").hours;
            if (hoursToExpiry >= 24) {
                return "Expires ".concat(expiryDateTime.toLocaleString(luxon_1.DateTime.DATE_FULL));
            }
            else {
                return "Expires in ".concat((0, StringManipulater_1.pluralise)(Math.ceil(hoursToExpiry), "hour"));
            }
        }
    }
    if (projectStatus === Types_1.ProjectStatus.Declined) {
        if (subStatus === Types_1.ProjectSubStatus.DeclinedExpired) {
            return "Link expired on ".concat(expiryDateTime.toLocaleString(luxon_1.DateTime.DATE_FULL));
        }
        else {
            return "Page was declined manually";
        }
    }
    return "";
}
